/**
 * src/lib/env.ts
 * =============================================================================
 * Validación y acceso tipado a las variables de entorno del cliente.
 *
 * La única variable obligatoria es `VITE_API_BASE_URL`.
 *
 * Variables esperadas:
 *  - VITE_API_BASE_URL → URL de la API (Node en el VPS de OVH).
 *                        En prod = `https://api.ploter.me` (la fija
 *                        `deploy-ovh.yml` al compilar).
 *                        En dev local = `http://localhost:3000` (`pnpm dev`
 *                        dentro de `backend/`; el puerto sale de `PORT`,
 *                        3000 por defecto en `backend/src/config.ts`).
 *
 * NO se exponen al cliente:
 *  - S3_*, BETTER_AUTH_SECRET, RESEND_API_KEY… → solo en el `.env` del VPS.
 * =============================================================================
 */

/**
 * Lee una variable de entorno obligatoria. Lanza un Error si falta o está vacía.
 * Así el bundle falla al instanciarse en lugar de en tiempo de uso.
 */
function required(name: string, value: string | undefined): string {
  if (!value || value.trim() === '') {
    throw new Error(
      `[env] Variable de entorno obligatoria no definida: ${name}. ` +
        `Revisa tu .env.local (desarrollo) o el paso de compilación de deploy-ovh.yml (producción).`,
    )
  }
  return value
}

export const env = {
  apiBaseUrl: required('VITE_API_BASE_URL', import.meta.env.VITE_API_BASE_URL),
  /** `true` en desarrollo local, `false` en build de producción. */
  isDev: import.meta.env.DEV,
} as const
